<!-- 企业级-平台运营-企业缴纳情况-开票资料 -->
<template>
  <div class="mainArea CBillingInfo">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <div class="tit">开具资质信息</div>
        <div class="cont clearfix">
          <el-form ref="form" status-icon :rules="rules" :model="billform" label-width="120px">
            <el-form-item label="纳税人识别号:" prop="idNum">
              <el-input v-model="billform.idNum" placeholder="请输入纳税人识别号" class="w400"></el-input>
            </el-form-item>
            <el-form-item label="开户行:" prop="bank">
              <el-input v-model="billform.bank" placeholder="请输入开户行" class="w400"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号:" prop="cardNum">
              <el-input v-model="billform.cardNum" placeholder="请输入银行卡号" class="w400"></el-input>
            </el-form-item>
            <el-form-item label="电话:" prop="tel">
              <el-input v-model="billform.tel" placeholder="请输入电话号码" class="w400"></el-input>
            </el-form-item>
            <el-form-item label="地址:" prop="address">
              <el-input v-model="billform.address" placeholder="请输入地址" class="w400"></el-input>
            </el-form-item>
            <div class="tit">邮寄信息</div>
            <el-form-item label="收件人:" prop="addressee">
              <el-input v-model="billform.addressee" placeholder="请输入收件人" class="w400"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" prop="phone">
              <el-input v-model="billform.phone" placeholder="请输入联系电话" class="w400"></el-input>
            </el-form-item>
            <el-form-item label="邮寄地址:" prop="mailAddress">
              <el-input v-model="billform.mailAddress" placeholder="请输入邮寄地址" class="w400"></el-input>
            </el-form-item>
            <el-form-item label="邮政编码:" prop="postalCode">
              <el-input v-model="billform.postalCode" placeholder="请输入邮政编码" class="w400"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitBill('form')">确认</el-button>
              <el-button @click="backUp">取消</el-button>
            </el-form-item>
          </el-form>
          
        </div>
      </div>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { platformApi } from "../../../../static/js/api.js"

  export default {
    name: 'CBillingInfo',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        billform:{
          idNum:'',//纳税人识别号
          bank:'',//开户行
          cardNum:'',//银行卡号
          tel:'',//电话
          address:'',//地址
          addressee:'',//收件人
          phone:'',//联系电话
          mailAddress:'',//邮寄地址
          postalCode:'',//邮政编码
        },
        rules:{
          idNum: [
            { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
            { pattern: /^(\w)+$/,message: '识别号只包括字母、数字、下划线'},
          ],
          bank: [
            { required: true, message: '请输入开户行', trigger: 'blur' },
          ],
          cardNum: [
            { required: true, message: '请输入银行卡号', trigger: 'blur' },
            { min: 16, max: 19, message: '请输入16到19位的银行卡号', trigger: 'blur' }
          ],
          tel: [
            { required: true, message: '请输入电话号码', trigger: 'blur' },
            { pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,message:'请输入正确的手机号'},
          ],
          address: [
            { required: true, message: '请输入地址', trigger: 'blur' },
          ],
          addressee: [
            { required: true, message: '请输入收货人', trigger: 'blur' },
          ],
          phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
            { pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,message:'请输入正确的手机号'},
          ],
          mailAddress: [
            { required: true, message: '请输入邮寄地址', trigger: 'blur' },
          ],
          postalCode: [
            { required: true, message: '请输入邮政编码', trigger: 'blur' },
          ],
        },
      }
    },
    mounted(){
    },
    created: async function () {

    },
    methods: {
      //提交开票信息
      submitBill(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.updateTicket()
          } else {
            return false;
          }
        });
      },
      async updateTicket(){
        let that = this;
        const dataObj = {
          'user_no': that.billform.idNum,//纳税人识别号
          'user_card_name': that.billform.bank,//开户行
          'user_card_no': that.billform.cardNum,//银行卡号
          'user_phone': that.billform.tel,//电话
          'user_address': that.billform.address,//地址
          'post_user_name': that.billform.addressee,//收件人
          'post_user_phone': that.billform.phone,//联系电话
          'post_user_address': that.billform.mailAddress,//邮寄地址
          'post_user_zip_code': that.billform.postalCode,//邮政编码
        }
        const res = await platformApi.updateTicket(dataObj)
        if(res.meta.code==200){
          showToast('更新票据成功！')
          setTimeout(function(){
            that.backUp()
          },3000)
        }else{
          showToast(res.meta.message)
        }
      },
      //返回上一级
      backUp(){
        this.$router.go(-1);
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss" scoped>
// .mainBodyContent{
//   height: calc(100vh - 194px);
//   overflow-y:auto; 
// }
.tit{
  font-size:18px;
  margin: 0px 0 20px;
}
.w400{ width: 400px;}
</style>



// WEBPACK FOOTER //
// src/components/Page/CPlatformOperate/CBillingInfo.vue